import { render, staticRenderFns } from "./leftNavigation.vue?vue&type=template&id=789a679a&"
import script from "./leftNavigation.vue?vue&type=script&lang=js&"
export * from "./leftNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports